export default __webpack_public_path__ + "static/DF_2022-6cf88c835ffd174610a2845685b32693.pdf";